import { render, staticRenderFns } from "./searchRecords.vue?vue&type=template&id=0b60bf1f&scoped=true"
import script from "./searchRecords.vue?vue&type=script&lang=js"
export * from "./searchRecords.vue?vue&type=script&lang=js"
import style0 from "./searchRecords.vue?vue&type=style&index=0&id=0b60bf1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60bf1f",
  null
  
)

export default component.exports